<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6"
          >Vehículos {{ filterState == "salon" ? "0 KM" : "Posventa" }}</span
        >
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="openDialog('add')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="vehicles"
        item-value="id"
        dense
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para agregar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <!-- <v-form ref="form">
            <v-text-field
              v-model="vehicle.plate"
              label="Marca"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.make"
              label="Marca"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.model"
              label="Modelo"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.year"
              label="Año"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.version"
              label="Versión"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.chassis_number"
              label="Chasis"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.color"
              label="Color"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="vehicle.price"
              label="Precio"
              outlined
              dense
              required
            ></v-text-field>
          </v-form> -->
          <vehicleForm
            ref="vehicleForm"
            :mode="action"
            :source="filterState == 'salon' ? 'salon' : 'servicio'"
            @save="saveVehicle"
            @close="dialog = false"
            :visibleFields="visibleFields"
          />
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveVehicle">Guardar</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showErrorSnackbar"
      :timeout="snackbarTimeout"
      color="red darken-2"
      top
      right
      multi-line
    >
      <div v-for="(error, index) in errors" :key="index">
        {{ error }}
      </div>
    </v-snackbar>
    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
    
    <script>
import axios from "@/plugins/axios.js";
import vehicleForm from "@/components/VehicleForm.vue";
export default {
  components: { vehicleForm },
  props: ["filterState"],
  data() {
    return {
      search: "",
      dialog: false,
      dialogTitle: "",
      headers: [
        { text: "Patente", value: "plate" },
        { text: "Marca", value: "make" },
        { text: "Modelo", value: "model" },
        { text: "Año", value: "year" },
        { text: "Chasis", value: "chassis_number" },
        { text: "Color", value: "color" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      vehicles: [], // Aquí se cargan los datos de usuarios desde la API
      vehicle: {
        id: null,
        make: "",
        body_type: "",
        model: "",
        year: "",
        plate: "",
        color: "",
        motor_number: "",
        motor_make: "",
        certificate_number: "",
        chassis_make: "",
      },
      action: "", // 'add' o 'edit'
      overlay: false,
      roles: [],
      visibleFields: [
        "make",
        "model",
        "year",
        "plate",
        "body_type",
        "chassis_make",
        "chassis_number",
        "color",
        "certificate_number",
        "motor_make",
        "motor_number",
        "status",
      ],
      errors: [],
      showErrorSnackbar: false,
      snackbarTimeout: 6000, // tiempo visible en ms: [],
    };
  },
  watch: {
    filterState: function (current, before) {
      this.getVehicles();
      if (this.filterState[0] === "salon") {
        this.visibleFields = [
          "make",
          "model",
          "year",
          "body_type",
          "chassis_make",
          "chassis_number",
          "color",
          "certificate_number",
          "motor_make",
          "motor_number",
        ];
      }else {
        this.visibleFields = [
          "make",
          "model",
          "year",
          "plate",
          "body_type",
          "chassis_make",
          "chassis_number",
          "color",
          "certificate_number",
          "motor_make",
          "motor_number",
          "status",
        ];
      }
    },
  },
  mounted() {
    this.getVehicles();
    if (this.filterState[0] === "salon") {
      this.visibleFields = this.visibleFields.filter(
        (field) => field !== "status" && field !== "plate"
      );
    }
  },
  methods: {
    getVehicles() {
      this.overlay = true;
      axios
        .get("/vehicles/getVehicles", {
          params: {
            filterData: this.filterState,
          },
        })
        .then((response) => {
          this.vehicles = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    openDialog(action, vehicle = null) {
      this.action = action;
      this.clearForm();
      if (this.action === "edit") {
        this.$nextTick(() => {
          if (this.$refs.vehicleForm) {
            this.$refs.vehicleForm.setVehicleData(vehicle);
          }
        });
        this.vehicle = vehicle;
      } else {
        this.$nextTick(() => {
          if (this.$refs.vehicleForm) {
            this.$refs.vehicleForm.clear();
          }
        });
      }
      this.dialog = true;
      this.dialogTitle =
        action === "add" ? "Agregar Vehículo" : "Editar Vehículo";
    },
    saveVehicle(vehicle) {
      if (this.action === "add") {
        this.createVehicle(vehicle);
      } else {
        this.updateVehicle(vehicle);
      }
    },
    validateFields() {
      return (
        this.vehicle.make,
        this.vehicle.model,
        this.vehicle.year,
        //this.vehicle.version,
        this.vehicle.plate,
        this.vehicle.chassis_number,
        this.vehicle.color,
        this.vehicle.price
      );
    },
    createVehicle(vehicle) {
      this.overlay = true;
      this.vehicle = vehicle;
      //Agregar validaciones
      /*if (!this.validateFields()) {
        this.msjModal = "Hay campos vacíos o sin seleccionar!";
        this.$refs["msj-modal"].show();
        return;
      }*/
      axios
        .post("vehicles/register", this.vehicle)
        .then((response) => {
          this.getVehicles();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
          this.dialog = false;
        })
        .catch((err) => {
          this.overlay = false;
          this.errors = [];
          if (err.response && err.response.status === 422) {
            const serverErrors = err.response.data.errors;
            for (let field in serverErrors) {
              this.errors.push(...serverErrors[field]);
            }
          } else {
            this.errors.push(
              "Ocurrió un error inesperado al guardar el vehículo."
            );
            console.error(err);
          }
          this.showErrorSnackbar = true;
        });
    },
    updateVehicle(vehicle) {
      this.overlay = true;
      axios
        .put("/vehicles/update", vehicle)
        .then((response) => {
          this.getVehicles();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
          this.dialog = false;
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    clearForm() {
      this.vehicle = {
        id: null,
        make: "",
        model: "",
        year: "",
        plate: "",
        //version: "",
        //price: 0,
      };
      this.isEdit = false;
    },
  },
};
</script>
  
  <style scoped>
/* Estilo para reducir la altura del input */
.small-input .v-input__control {
  height: 30px !important; /* Ajusta la altura */
  font-size: 9pt; /* Ajusta el tamaño del texto */
  padding: 4px 8px !important; /* Reduce el padding interno */
}
.small-input .v-label {
  font-size: 0.75rem; /* Reduce el tamaño de la etiqueta */
  top: -6px; /* Ajusta la posición de la etiqueta */
}
</style>
    